import {
  HTTP_GETBUDGETCOMPDBYDEPT_FETCHING,
  HTTP_GETBUDGETCOMPDBYDEPT_SUCCESS,
  HTTP_GETBUDGETCOMPDBYDEPT_FAILED,
  HTTP_RESET_GETBUDGETCOMPDBYDEPT,
  server,
  OK,
  YES,
} from "src/Constants";
import { httpClient } from "src/utils/HttpClient";

export const setStateBudgetCompDDToFetching = () => ({
  type: HTTP_GETBUDGETCOMPDBYDEPT_FETCHING,
});

export const setStateBudgetCompDDToSuccess = (payload) => ({
  type: HTTP_GETBUDGETCOMPDBYDEPT_SUCCESS,
  payload,
});

export const setStateBudgetCompDDToFailed = (payload) => ({
  type: HTTP_GETBUDGETCOMPDBYDEPT_FAILED,
});

export const clearBudgetCompDD = () => {
  return async (dispatch) => {
    dispatch(setStateBudgetCompDDToSuccess([]));
  };
};

export const getBudgetCompDD = (country, company, brand, year, item) => {
  return async (dispatch) => {
    dispatch(setStateBudgetCompDDToFetching());
    try {
      const result = await httpClient.put(
        `${server.GETBUDGETCOMPBYDEPTD_URL}/${country}/${company}/${brand}/${year}`,
        item,
        {
          headers: {
            authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );

      dispatch(setStateBudgetCompDDToSuccess(result.data));
      return Promise.resolve(result.data[0]);
    } catch (error) {
      dispatch(setStateBudgetCompDDToFailed());
    }
  };
};
